
































import Vue from 'vue';

export default Vue.extend({
  props: {
    hash: {
      type: String,
      required: true,
    },
  },
});
